import React, { Component } from 'react';
import propsTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Panel } from 'react-bootstrap';
import { TagCloud } from "react-tagcloud";

import { fetchTagCounts } from '../actions/tagActions';
import { loginUser, logoutUser, registerUser } from '../actions/userActions';

class Tags extends Component {

  componentWillMount() {
    if (Object.keys(this.props.userinfo).length !== 0) {
      this.props.fetchTagCounts(this.props.userinfo.token)
    }
  }

  render() {
    var tags_list = []
    if (Object.keys(this.props.tags) !==0) {
      if (this.props.tags.length>0) {
        this.props.tags.forEach((tag) => {
          tags_list.push(
            <Panel key={tag.id}>
              <Panel.Heading>
                <Panel.Title componentClass="h3">
                  <a nohref="true" id={tag.id}>{tag.name}</a>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body>
                <TagCloud
                  minSize={12}
                  maxSize={35}
                  tags={tag.tags}
                  onClick={tag => this.props.history.push(`/errors/tag=` + tag.key)}
                />
              </Panel.Body>
              <Panel.Footer />
            </Panel>
          )
        });
      }
    }
  
    return (
      <Panel>
        <Panel.Heading><h3>科目错题知识点云</h3></Panel.Heading>
        <Panel.Body>
          {tags_list}
        </Panel.Body>
      </Panel>
    )
  }
}

Tags.propsTypes = {
  loginUser: propsTypes.func.isRequired,
  registerUser: propsTypes.func.isRequired,
  logoutUser: propsTypes.func.isRequired,
  fetchTagCounts: propsTypes.func.isRequired,
  userinfo: propsTypes.object,
  tags: propsTypes.list,
}

const mapStateToProps = state => ({
  userinfo: state.users.item,
  tags: state.tags.items,
})

export default withRouter(
  connect(
    mapStateToProps,{
      loginUser, 
      logoutUser, 
      registerUser, 
      fetchTagCounts}
  )(Tags)
);


// WEBPACK FOOTER //
// ./src/components/TagsShow.js